export default "<iframe src=\"https://gallagherapp.com/us/\" title=\"W3Schools Free Online Web Tutorials\" width='{{width}}' height=\"{{height}}\"></iframe>"